import { CHAINS } from './EthereumConnection/consts'

export const NETWORK_FEE_IN_BOUNDS = 1

export const TOKEN_SETTINGS = {
  tokenAddress: '0xc551b009C1CE0b6efD691E23998AEFd4103680D3',
  vestingAddress: '0xf25a717Be582d10427Ca0Cb87207f932611d9B09',
  internalAddress: '0xe2abD1E57c8D6f0D21645a8a0Af6C4251a4395f5',
  zkBridgeHubAddress: '0x01146571bdcc6ddcb2f6ae9222231b0d7d8de532',
  zkBridgeAddress: '0x13b839215a2c292c604e563c07d282a2daf6a6ac',
  name: 'BOUND',
  decimals: 18,
  unitRatio: 1,
  chain: CHAINS.devnet,
  zkChain: CHAINS.devnet_zk,
}
